import EnvironmentUtils from "./EnvironmentUtils.js";
import { v1 as uuidv1 } from "uuid";
import { observable, reaction, action, computed } from "mobx";

export default class HttpUtils {
    logRedirectionTrace = false;

    @observable static authenticatedActorIdHeader = "flammapa";
    @observable static pendingRequests = observable.map();
    @observable static bool_isSpinnerOn = false;
    @observable static reloadingBeingHandled = false;


    static watchRequests = reaction(
        () => this.pendingRequests.size,
        (length) => this.helper_toggleSpinner(length > 0)
    );

    @action
    static getBaseUrl() {
        if (process.env.NODE_ENV.includes("development")) {
          return EnvironmentUtils.isBirdApp() ? "https://localhost:8083/" : "https://localhost:8082/"
        } else {
          return window.location.origin + "/"
        }
    }

    static generateRequestId() {
        return uuidv1();
    };

    @action
    static addRequest = (requestId, description) => {
        this.pendingRequests.set(requestId, description);
    }

    @action
    static removeRequest = (requestIdToBeRemoved) => {
        this.pendingRequests.delete(requestIdToBeRemoved);
    }

    @computed
    static get isThereAnyPendingRequest() {
      return this.pendingRequests.size > 0;
    }

    @computed
    static get getPendingRequests() {
      return Array.from(this.pendingRequests.values());
    }

    @action
    static helper_turnOffSpinner = () => {
        this.bool_isSpinnerOn = false;
    }
  
    @action
    static helper_turnOnSpinner = () => {
        this.bool_isSpinnerOn = true;
    }

    @computed
    static get computed_bool_isSpiner() {
        return this.bool_isSpinnerOn;
    }
  
    @action
    static helper_toggleSpinner = (toggle) => {
        if (toggle && !this.computed_bool_isSpiner) {
            this.helper_turnOnSpinner();
        } else if (!toggle) {
            this.helper_turnOffSpinner();
        }
    }

    static amendHeadersIfNeeded = (headers) => {
        const amendedHeaders = headers;
        amendedHeaders.append("x-sdd-app", "true");
        const authActorId = this.getAuthenticatedActorIdHeader();
        if (authActorId !== null) {
          amendedHeaders.append("Authenticated-actor-id", authActorId);
        }
        return amendedHeaders;
    };

    static getAuthenticatedActorIdHeader = () => {
        return process.env.NODE_ENV.includes("development")
          ? this.authenticatedActorIdHeader
          : null;
    };

    @action
    static updateAuthenticatedActorIdHeader = (selectedDevUser) => {
      this.authenticatedActorIdHeader = selectedDevUser;
    };
    
    static reloadIfRedirectedToLogin = (response) => {
        if (this.logRedirectionTrace) console.log("reload check", response);
        if (this.logRedirectionTrace)
            console.log("content-type header", response.headers.get("content-type"));
        // agreed with backend that status code 333 or redirection to login/logout or ajax response that is not json/stream means session expired/invalid
        if (
            response.status === 333 ||
            (response.redirected === true &&
            (response.url.endsWith("saml/login") ||
                response.url.endsWith("logout"))) ||
            (response &&
            response.headers &&
            response.headers.get("content-type") &&
            response.headers.get("content-type").includes("text/html"))
        ) {
            if (this.logRedirectionTrace) console.log("requesting reload");
            this.reloadPage();
        }
    };

    @computed
    static get getReloadingBeingHandled() {
        return this.reloadingBeingHandled;
    }
  
    @action
    static reloadPage = () => {
        if (this.logRedirectionTrace) {
            console.log("reloading already in progress?", this.reloadingBeingHandled);
        }
        if (!this.reloadingBeingHandled) {
            if (this.logRedirectionTrace) console.log("reloading page");
            this.redirectionBeingHandled = true;
    
            window.location.href = this.str_URL_BASE + "logout";
    
            return;
        }
    };
}